import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { ApplicationState, CommanderThunkDispatch } from '@mews-commander/types';
import { isAllCollapsed } from '../ducks/billing';
import { collapseAll, expandAll } from '../actions/billing';

interface StateProps {
    isAllCollapsed: boolean;
}

interface DispatchProps {
    collapseAll(): void;
    expandAll(): void;
}

interface OwnProps {
    scope: string;
}

export const connectExpandCollapseAll = connect<StateProps, DispatchProps, OwnProps, ApplicationState>(
    createStructuredSelector({
        isAllCollapsed,
    }),
    (dispatch: CommanderThunkDispatch, { scope }) => ({
        collapseAll: () => dispatch(collapseAll(scope)),
        expandAll: () => dispatch(expandAll(scope)),
    })
);
